import React from 'react';
import Image from 'next/legacy/image';

import { IPlanInfoFields } from '../../../types/contentful';

import RichText from '../RichText';

export function PlanInfo({ color, logo, copy, button }: IPlanInfoFields) {
  const { file, description } = logo?.fields ?? {};

  const bgColor = color
    ? color.startsWith('#')
      ? color
      : `#${color}`
    : undefined;

  return (
    <div
      role="listitem"
      data-testid="plans-info"
      className="mb-6 flex flex-col items-center justify-between overflow-hidden rounded-[56px] p-0 tablet:mx-2 tablet:mb-0 tablet:w-[30%] tablet:rounded-[40px]"
    >
      {file && (
        <div
          className="flex h-[110px] w-full items-center justify-center pt-8 pb-6"
          style={bgColor ? { backgroundColor: bgColor } : undefined}
        >
          <div className="relative w-[75%]">
            <Image
              src={`https:${file?.url}`}
              alt={description ?? ''}
              height={56}
              width={239}
              className="h-full max-w-[75%] object-contain"
            />
          </div>
        </div>
      )}
      <div className="flex h-full w-full flex-col justify-between bg-[#F3F3F3] px-6 pb-8 pt-6 desktop:px-8 desktop:pb-12 desktop:pt-6">
        {copy && (
          <div>
            <RichText data={copy} />
          </div>
        )}
        {button && (
          <div className="mt-6 flex [&_a]:mx-auto [&_a]:w-full tablet:[&_a]:w-[80%]">
            <RichText data={button} />
          </div>
        )}
      </div>
    </div>
  );
}
